import {sellerConstants } from '../../_constants/seller.constants';

const initialState = { orgLoading : true, organisations: '', orgError: false};

export function organisations(state = initialState, action) {
    switch (action.type) {
      case sellerConstants.REQUEST_ORGANISATIONS:
        return {
          orgLoading: true,
          organisations: '',
          orgError: false
        };
      case sellerConstants.RECEIVE_ORGANISATIONS:
        return {
          orgLoading: false,
          organisations: action.organisations.data.seller_credit_list,
          orgError: false
        };
      case sellerConstants.ORGANISATINS_ERROR:
        return { 
          orgLoading: false,
          organisations: '',
          orgError: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/sellers/organisations.reducer.js